import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sms: {
        bnum_list: [],
        has_selected_bnum: false,
        selected_bnum: '',
        country: '',
        client_id: '',
        username: '',
    },
    webcall: {
        bnum_list: [],
        has_selected_bnum: false,
        selected_bnum: '',
        country: '',
        client_id: '',
        username: '',
    },
};

const numberManagementSlice = createSlice({
    name: 'numberManagement',
    initialState,
    reducers: {
        setSmsNumbersData(state, action) {
            state.sms = action.payload;
        },
        setWebcallNumbersData(state, action) {
            state.webcall = action.payload;
        },
        resetNumberManagement(state) {
            Object.assign(state, initialState);
        },
    },
});

export const {
    setSmsNumbersData,
    setWebcallNumbersData,
    resetNumberManagement,
} = numberManagementSlice.actions;

export default numberManagementSlice.reducer;
